// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CreateRenterAccountWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateRenterAccountWebApiRequestDto } from '../..';

export const CreateRenterAccountWebApiHandler_createRenterAccount_Path = '/api/web/v1/createRenterAccount';

/**
 * create a renter account
 */
export const CreateRenterAccountWebApiHandler_createRenterAccount = (
  postData: CreateRenterAccountWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateRenterAccountWebApiRequestDto, void>(
    {
      endpoint: CreateRenterAccountWebApiHandler_createRenterAccount_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
